import Type from "@/model/types/Type";

const type = {
    EVIDENCE: 100, /*ABA VISTORIA APENAS*/
    ESTATE: 105, /*ABA VISTORIA + 'ITENS'*/
    OCCURRENCE: 200, /*ABA VISTORIA E APONTAMENTO*/
    CONDO: 210, /*Não implantado ainda*/
    BUDGET: 300, /*ABA VISTORIA + APONTAMENTO + ORÇAMENTO*/
}

const list = [
    {
        value: type.EVIDENCE,
        text: "Inspeção Básica",
    },
    {
        value: type.OCCURRENCE,
        text: "Inspeção com Apontamentos (Não Conformidades, Anomalias e Ocorrências)",
    },
    {
        value: type.ESTATE,
        text: "Inspeção Imobiliária",
    },
    {
        value: type.CONDO,
        text: "Inspeção Condominial",
    },
    {
        value: type.BUDGET,
        text: "Inspeção Orçamentária",
    },
]

const contains = function (typeInput) {
    return Type.contains(list, typeInput)
}

export default {
    type,
    list,
    contains,
}